// import { useTheme } from '../components/common/ThemeContext'; 
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SideBar from '../../Components/AdminDashboard/Admincommon/SideBar';
import Header from '../../Components/AdminDashboard/Admincommon/Header';
// import Overview from '../../Components/AdminDashboard/AdminOverview/AdminOverview';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/admin/admin_assets/css/sb-admin-2.min.css';
import '../../../src/pages/admin/admin_assets/css/common.css';
import '../../../src/pages/admin/admin_assets/css/responsive.css';
import '../../../src/pages/admin/admin_assets/css/Overview.css';
import HideText from '../../Components/AdminDashboard/Admincommon/HidePageText';
import AdminOverview from '../../Components/AdminDashboard/AdminOverview/AdminOverview';

const AdminOverviewPage = () => 
{


    const baseClass = 'container-fluid';
  
    const className = `${baseClass}`;


    const navigate = useNavigate();
    const location = useLocation();

    // useEffect(() => {
    //     const token = sessionStorage.getItem('userId');
    //     if (!token) {
    //         navigate('/');
    //     }
    // }, [navigate]);

    return (
        <div id="page-top">
            <div id="wrapper" className='admin_sidebar'>
                <SideBar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content" className={className}>
                        <Header />
                        {/* <p style={{marginTop:"200px"}}>Test Admin</p> */}
                        <AdminOverview />
                    </div>
                </div>
            </div>

            <div className="modal fade" id="logoutModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
                            <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Select "Logout" below if you are ready to end your current session.
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
                            <a className="btn btn-primary" href="login.html">Logout</a>
                        </div>
                    </div>
                </div>
            </div>

            <HideText/>
        </div>
    );
};

export default AdminOverviewPage;
